export default {
  title: {
    en: 'FAMILY TIME!',
    ar: 'وقت العائلة!'
  },

  description: {
    en: 'Welcome to Family Mode! Design your family crew and dive into the fun! Don\'t worry — you can switch things up later.',
    ar: `مرحبًا بك في الفاميلي مود!
        صمّم فريق العائلة الخاص بكم وابدأوا المرح!
        لا تقلق — يمكنك التغيير في أي وقت لاحقًا.`
  },

  button: {
    en: 'Okay!',
    ar: 'حسنًا!'
  }
};
